"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_EN_TRANS = {
    'time picker': 'Time Picker',
    'today': 'Today',
    'set time': 'Set Time',
    'close': 'Close',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
    'hour': 'Hour',
    'minute': 'Minute',
    'second': 'Second',
};
//# sourceMappingURL=en.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/en.js
// module id = ../../../../ng-pick-datetime/locale/en.js
// module chunks = 18